import { t } from "../services/utils";
import React from "react";
import { primaryDark, primaryDark60 } from "../constants/colors";
import Avatar from "@material-ui/core/Avatar";
const ProfileImageView = props => {
  let styles = {
    container: {
      position: "relative",
      backgroundColor: "transparent",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    initialsContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      width: 48,
      height: 48,
      backgroundColor: primaryDark,
      color: "white",
      borderRadius: 24
    },
    thumbnail: {
      width: "100%",
      height: "100%"
    },
    placeholderIcon: {
      fontSize: props.placeholderSize ? `${props.placeholderSize}px` : "42px",
      color: primaryDark60
    }
  };
  const {
    initials,
    size = 48
  } = props;
  if (props.photoId || props.photoUrl) {
    let photoUrl;
    if (props.photoId) {
      photoUrl = `/users_photos/${props.photoId}`;
    } else {
      photoUrl = props.photoUrl;
    }
    if (process.env.NODE_ENV === "stage") {
      photoUrl = process.env.ROOT_URL + photoUrl;
    }
    return <div style={{
      ...styles.container,
      ...props.style
    }}>
        {props.circular ? <Avatar src={photoUrl} sizes={size} style={{
        width: size,
        height: size
      }} /> : <img style={styles.thumbnail} src={photoUrl} />}
      </div>;
  } else if (initials) {
    return <div style={styles.initialsContainer}>{initials.toUpperCase()}</div>;
  } else {
    return <div style={{
      ...styles.container,
      ...props.style
    }}>
        <i className={"material-icons"} style={styles.placeholderIcon}>{t("face")}</i>
      </div>;
  }
};
export default ProfileImageView;